<div class="{{'sidemenu-wrapper '+(collapseMenu?'collapse-menu':'')}}">
    <div class="menus">
        <div class="primary-menus">
            <div class="menu-group">
                <div class="menu-group-header">

                </div>

                <div class="menu-group-list">
                    <ul>
                        @for (linkObject of menuObjects[userRole]['primary_menu']; track $index) {
                        <a [routerLink]="[linkObject.link]" routerLinkActive="router-link-active"
                            class="g-just-flex gap-8" matTooltip="{{linkObject.title}}" title="{{linkObject.title}}"  matTooltipTouchGestures="off">
                            <mat-icon>{{linkObject['icon']}}</mat-icon>
                            <span>
                                {{ linkObject.title}}
                            </span>
                        </a>
                        }


                    </ul>
                </div>





            </div>
            @for (linkObject of menuObjects[userRole]['grouped_menu']; track $index) {
            <div class="menu-group">
                <div class="menu-group-header">
                    {{linkObject[0]}}
                </div>

                <div class="menu-group-list">
                    <ul>
                        @for (specLinks of linkObject[1]; track $index) {
                        <a [routerLink]="[specLinks.link]" routerLinkActive="router-link-active"
                            class="g-just-flex gap-8">
                            <mat-icon>{{specLinks['icon']}}</mat-icon>
                            <span>
                                {{ specLinks.title}}
                            </span>
                        </a>
                        }


                    </ul>
                </div>





            </div>
            }
        </div>
    </div>
</div>